import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";

export default function CustomApproved2DisburseOutHMFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-approved-switchach"
        // label="Switch to No ACH"
        label="Disable ACH"
        variant="contained"
        size="medium"
        color="warning"
        sx={{
          marginLeft: "10px",
          width: "auto",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-approved-switchach"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xs"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `applications/actions/approved/disbursementOutSideHM`;
            const formData = new FormData(event.currentTarget);
            var uploadFileId = document.getElementById("uploadFileId") as any;
            if (uploadFileId) {
              formData.append("uploadFileIds", uploadFileId.value);
            }
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.methold = "NO";
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Please Confirm
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            <Typography variant="body1">
              Are you sure change application to NO ACH ? click "Submit" button
              to save it
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            label="Disable ACH"
            color="warning"
            sx={{
              marginLeft: "10px",
              width: "auto",
              "&:hover": { bgcolor: "gray" },
            }}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
